/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Banner_TitleInputs */

const en_cookie_banner_title = /** @type {(inputs: Cookie_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies and privacy`)
};

const es_cookie_banner_title = /** @type {(inputs: Cookie_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies y privacidad`)
};

const fr_cookie_banner_title = /** @type {(inputs: Cookie_Banner_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies et confidentialité`)
};

/**
* | output |
* | --- |
* | "Cookies and privacy" |
*
* @param {Cookie_Banner_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const cookie_banner_title = /** @type {((inputs?: Cookie_Banner_TitleInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Banner_TitleInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cookie_banner_title(inputs)
	if (locale === "es") return es_cookie_banner_title(inputs)
	return fr_cookie_banner_title(inputs)
});